import { useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import timespentContex from "../timespent.contex";
import TimeSpent from "./TimeSpent";

const Main = () => {
  const { SAP_ID } = useParams();

  const { officers } = useSelector((state) => state.officers);

  const { officer, setOfficer, plan, planDate } = useContext(timespentContex);

  useEffect(() => {
    if (!SAP_ID || !officers?.length) return;

    const officer = officers.filter((item) => item.SAP_ID === SAP_ID);

    setOfficer(officer[0]);
  }, [officers]);

  return (
    <div
      className="main-ctr"
      style={{ marginRight: "1rem", marginTop: "-3rem" }}
    >
      <div className="calendar-bar">
        <div
          className="info-bar"
          // style={{
          //   padding: "0 1rem",
          //   width: "100%",
          //   display: "flex",
          //   justifyContent: "start",
          // }}
        >
          <div className="officer-details">
            <div className="o-name">SAP_ID : {officer?.SAP_ID} </div>
            <div> Territory : {officer?.SAP_ID} </div>
          </div>
        </div>
      </div>
      <TimeSpent />
    </div>
  );
};

export default Main;
